import { BankingService } from '@/modules/banking/services'
import request from '@/modules/base/util/request'
import config from '@/modules/banking/config'
import { getProcessIdHeader } from './generateProcessId'

export const silentPinUpdate = (data, meta, processId) => {
  const { urls } = config
  const { transactionId, providePinRequest: { token } } = data
  const requestData = { ...meta }

  return BankingService.psd2.callbacks.pin(token, requestData, processId)
    .then(() => {
      if (requestData.storePin && requestData.contactId) {
        const url = urls.autoSyncContact(requestData.contactId)
        return request(url, { method: 'PUT', auth: true, data: { autoSyncBookings: true }, headers: { ...getProcessIdHeader(processId) } })
      }
    })
    .then(() => {
      return Promise.resolve(data)
    })
    .catch((error) => {
      error.transactionId = transactionId
      return Promise.reject(error)
    })
}

export default silentPinUpdate
